'use strict';

(function ($) {
    $.agito = $.agito || {};
    $.agito.utilities = $.agito.utilities || {};

    // Focus logic
    $.agito.utilities.setFocus = function (selector) {
        var firstItem = $(selector || 'body').find(':input:visible:enabled:not(button):not(hidden):first');
        if (!firstItem.is('.form-control.ui-igcombo-field.ui-corner-all.ui-unselectable')) {
            firstItem = $(selector || 'body').find(':input:visible:enabled:not(button):not([readonly]):first');
        }
        
        if (firstItem.hasClass('no-focus') === false)
            firstItem.focus();
    };
})($);

$(document).ready(function () {
    /* Sets focus on first visible/enabled element on page.
     * If this will run slowly consider replacing it with HTML5 attribute autofocus="autofocus" in all views. 
     */
    $.agito.utilities.setFocus();
});